import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import CategoryIcon from '@mui/icons-material/Category';
import { useTypeAttributeStore } from "../../hooks/useTypeAttributeStore";
import { TypeAttributeModal } from "./components/TypeAttributeModal";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    // { type: 'text', field: 'createdby', label: 'Definido por', align:'center' },
    { type: 'text', field: 'status', label: 'Estado', align:'center', format:(row) => row.status == 1 ? 'Activado' : 'Desactivado' }
];

export const TypeAttributesView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActiontypeAttribute, gettypeAttribute, gettypeAttributeByCompany, deletetypeAttribute, changeStatustypeAttribute } = useTypeAttributeStore();

    const [loading, setLoading] = useState(false);
    const [attributes, setAttributes] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        gettypeAttributeApi()
    },[])

    const gettypeAttributeApi = async(search='') => {
        try {
            setLoading(true);
            const response = await gettypeAttributeByCompany(search);
            if(!response){
                setAttributes([]);
                setLoading(false);
                return false;
            }else{
                setAttributes(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActiontypeAttribute('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActiontypeAttribute('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActiontypeAttribute('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
   
    const onSwitch = async(rowSelected) => {
        const statusrow = rowSelected?.status == '0' ? '1' : '0';
        setLoading(true);
        const response:any = await changeStatustypeAttribute(rowSelected.id, {status:statusrow});
        if(response){
            gettypeAttributeApi();
            setLoading(false);
            setRowSelected('');
        }else{
            setLoading(false);
            return false;
        }
    }

    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deletetypeAttribute(rowSelected.id)
            if(response){
                gettypeAttributeApi();
                setShowModalConfirm(false);
                setRowSelected('');
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { gettypeAttributeApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Tipo atributos de producto'}
                    columns={columns} 
                    loading={loading}
                    rows={attributes || []}
                    onRowClick={() => {}}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Agregar'}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    icon_helper={ <CategoryIcon fontSize="small" /> }
                    onSwitch={onSwitch}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {
                showModal && (
                    <TypeAttributeModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        typeattributeSelected = {rowSelected}
                        listTypeAttribute = {gettypeAttributeApi}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                        clearState = {clearState}
                    />
                )
            }
        </>
    )
}